import React from 'react';

import { useEmailMessageQuery } from '@dashboard/generated/wp/platform';
import { Alert } from '@mui/material';

type Props = {
  waypointEventId: string;
};
export default function RenderError({ waypointEventId }: Props) {
  const { data } = useEmailMessageQuery({ variables: { id: waypointEventId } });
  const model = data?.EmailMessage;
  if (model === undefined) {
    return null;
  }
  const { renderError } = model;
  if (!renderError) {
    return null;
  }
  return (
    <Alert color="error">
      {renderError.message}
      <pre>{renderError.template}</pre>
    </Alert>
  );
}
